import React from "react";
import styles from "./Products.module.css";

import productImg1 from "../../../assets/images/Products/FMB120.png";
import productImg2 from "../../../assets/images/Products/FMB202.png";
import productImg3 from "../../../assets/images/Products/FMB641.png";
import productImg4 from "../../../assets/images/Products/FMB920.png";

import Product from "./Product";
import TitleH2 from "../../../components/TitleH2/TitleH2";
import DashedBtn from "../../../components/Button/DashedBtn";
function Products() {
  const products = [
    {
      id: 1,
      name: "FMB120",
      image: productImg1,
      description:
        "ردیاب خودرو FMB120 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB120 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    },
    {
      id: 2,
      name: "FMB202",
      image: productImg2,
      description:
        "ردیاب خودرو FMB202 ساخت شرکت تلتونیکا، یک ردیاب ضد آب و حرفه‌ای با آنتن داخلی GNSS/GSM و باتری داخلی Ni-MH است. این ردیاب با طراحی مقاوم و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB202 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    },
    {
      id: 3,
      name: "FMB641",
      image: productImg3,
      description:
        "ردیاب خودرو FMB641 ساخت شرکت تلتونیکا، یک ترمینال پیشرو با اتصال GNSS/GSM برای برنامه‌های پیشرفته است. این ردیاب با طراحی پیشرفته و قابلیت‌های گسترده، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB641 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    },
    {
      id: 4,
      name: "FMB920",
      image: productImg4,
      description:
        "ردیاب خودرو FMB920 ساخت شرکت تلتونیکا، یک ردیاب فشرده با آنتن داخلی GNSS/GSM و باتری داخلی است. این ردیاب با طراحی کوچک و قابلیت‌های پیشرفته، امکان ردیابی دقیق و مدیریت ناوگان خودروها را فراهم می‌کند. FMB920 با پشتیبانی از سنسورهای متعدد و قابلیت‌های امنیتی پیشرفته، انتخابی ایده‌آل برای شرکت‌های حمل و نقل و مدیریت ناوگان است.",
    },
  ];

  return (
    <>
      <section
        id="homePage-products__sec"
        className={`
          ${styles.productsSec} 
          ${styles.productsCont} 
          products__cont`}>
        <TitleH2 className={`${styles.productTitle}`}>محصول‌های ما</TitleH2>

        <div className={`${styles.products}`}>
          {products.map((p) => (
            <Product
              key={p.id}
              name={p.name}
              image={p.image}
              description={p.description}
            />
          ))}
        </div>
        <div className={styles.moreProductsSec}>
          <DashedBtn className={`${styles.moreProductsBtn}`} link={"/Products"}>
            محصولات بیشتر ...
          </DashedBtn>
        </div>
      </section>
    </>
  );
}

export default Products;
